module.exports = __webpack_public_path__ + "static/media/Google Pixel 4 XL Clearly White.25615935.png";